// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"af404535","453":"5f768c7d"}[chunkId] + ".chunk.js";
};